/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Translation_Merge_Error_ToastInputs */



/**
* | output |
* | --- |
* | "Error merging Event Groups. {error}" |
*
* @param {Translation_Merge_Error_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const translation_merge_error_toast = /** @type {((inputs: Translation_Merge_Error_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Translation_Merge_Error_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Erreur lors de la fusion des groupes d'evenements. ${i?.error}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Fehler beim Zusammenführen der Ereignisgruppen. ${i?.error}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Errore durante l'unione dei gruppi di eventi. ${i?.error}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Ошибка при слиянии групп событий. ${i?.error}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Error al fusionar grupos de eventos. ${i?.error}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`合并事件组时出错。${i?.error}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`イベント グループの結合中にエラーが発生しました。${i?.error}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`इवेंट समूहों को मर्ज करने में त्रुटि। ${i?.error}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Erro ao mesclar grupos de eventos. ${i?.error}`)
	return /** @type {LocalizedString} */ (`Error merging Event Groups. ${i?.error}`)
});